
//const feapiurl = "http://api.evolve.de/evolvedemopage/api/frontend/";
const feapiurl = "https://api.evolvejobs.de/demo/api/frontend/";
export default feapiurl;